// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAQaFVO7qHANdw9n5ioRIEn-ijMd0xS29Y",
  authDomain: "susurobo-call-for-me.firebaseapp.com",
  projectId: "susurobo-call-for-me",
  storageBucket: "susurobo-call-for-me.firebasestorage.app",
  messagingSenderId: "3055119120",
  appId: "1:3055119120:web:f4732e3581467ea1e91395",
  measurementId: "G-6SL76TP0T6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication
export const auth = getAuth(app);

// Initialize Firestore (using named 'default' database)
export const db = getFirestore(app, 'default');

// Initialize Analytics (optional)
export const analytics = getAnalytics(app);

export default app;
